import { doGet, doPost, doPost2, doPost2WithFormData } from 'services/common'

const getProfileInfo = () => {
  return doGet('/user/profile')
}
const getSweepsEntries = page => {
  //TODO - This needs to be fixed in common.js
  // const params = {
  //   page: page
  // }

  return doGet(`/user/sweepsEntries?page=${page}`)
}

const getNumberOfSweepsEntryPages = () => {
  return doGet(`/user/numberOfSweepsEntryPages`)
}

const inviteFriend = email => {
  return doPost('/user/mailingList', { email: email })
}

const requestEmailChange = async email => {
  let payload = {
    newEmailAddress: email,
  }

  return doPost2WithFormData(`/user/requestEmailChange`, payload)
}

const confirmEmailChange = async token => {
  let payload = {
    token: token,
  }

  return doPost2WithFormData(`/user/confirmEmailChange`, payload)
}

export {
  confirmEmailChange,
  getProfileInfo,
  getSweepsEntries,
  getNumberOfSweepsEntryPages,
  inviteFriend,
  requestEmailChange,
}
